import { ClipboardCheck, FileSearch, History, ShieldCheck, UserSearch } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { MenuCard } from "@/components/ui/menu-card";
import { useMe } from "@/lib/hooks/use-clients";
import { useT } from "@/lib/i18n/use-t";
import { hasPermission, type Permission } from "@/lib/permissions";
import { T } from "./page.i18n";

export default function CompliancePage() {
  const t = useT(T);
  const navigate = useNavigate();
  const { me, isLoading } = useMe();
  const userPermissions = (me?.permissions || ["advisor"]) as Permission[];

  useEffect(() => {
    if (!isLoading && !hasPermission(userPermissions, "compliance")) {
      navigate("/", { replace: true });
    }
  }, [isLoading, userPermissions, navigate]);

  if (isLoading || !hasPermission(userPermissions, "compliance")) return null;

  return (
    <div className="space-y-6">
      <PageHeader title={t.title} description={t.description} />

      <div className="grid gap-6 md:grid-cols-2">
        <MenuCard
          href="/compliance/clients"
          title={t.clientsReview}
          description={t.clientsReviewDescription}
          icon={UserSearch}
        />
        <MenuCard
          href="/compliance/batch-lookup"
          title={t.batchLookup}
          description={t.batchLookupDescription}
          icon={ShieldCheck}
        />
        <MenuCard
          href="/compliance/flows"
          title={t.flowsReview}
          description={t.flowsReviewDescription}
          icon={FileSearch}
        />
        <MenuCard
          href="/compliance/approvals"
          title={t.flowApprovals}
          description={t.flowApprovalsDescription}
          icon={ClipboardCheck}
        />
        <MenuCard
          href="/compliance/identity-changes"
          title={t.identityChanges}
          description={t.identityChangesDescription}
          icon={History}
        />
      </div>
    </div>
  );
}
